<script lang="ts">
  export let title: string;
  export let description: string;
  export let keywords: string[];
  export let robots: string[];
  export let faviconUrl: string;
  export let socialTitle: string;
  export let socialDescription: string;
  export let socialImageUrl: string;
  export let hreflangXDefault: boolean;
  export let hreflangAlternates: HreflangAlternative[];
  export let canonical: string;
  export let metadataSeoSchemaScript: string;

  export let ogUrl: string;
  export let ogLocale: string;
  export let ogSiteName: string;
  export let twitterCard: string;
  export let twitterSite: string;
  export let twitterCreator: string;
  export let twitterDomain: string;
  export let pinterestVerificationToken: string;
  export let bingVerificationToken: string;
  export let googleSiteVerificationToken: string;
  export let routeMetadata: Record<string, any>;

  export let openSearchXmlUrl: string;
</script>

<svelte:head>
  <!-- Favicon Link Tag -->
  <link rel="icon" href={faviconUrl} />

  <!-- SEO Meta Tags -->
  <title>{title}</title>
  {#if description}
    <meta name="description" content={description} />
  {/if}
  {#if keywords && keywords.length > 0}
    <meta name="keywords" content={keywords.join(', ')} />
  {/if}
  {#if robots && robots.length > 0}
    <meta name="robots" content={robots.join(', ')} />
  {/if}
  <link rel="canonical" href={canonical} />

  <!-- OG Meta Tags -->
  <meta property="og:title" content={socialTitle} />
  <meta property="og:url" content={ogUrl} />
  {#if socialImageUrl}
    <!-- Use html to unescape ampersand in url query parameters -->
    {@html `<meta property="og:image" content="${socialImageUrl}" />`}
  {/if}
  <meta property="og:locale" content={ogLocale} />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content={ogSiteName} />
  {#if socialDescription}
    <meta property="og:description" content={socialDescription} />
  {/if}

  <!-- hreflang Alternatives Link Tags -->
  {#if hreflangAlternates}
    {#each hreflangAlternates as hreflangAlternate}
      <link rel="alternate" hreflang={hreflangAlternate.locale} href={hreflangAlternate.url} />
    {/each}
  {/if}

  <!-- hreflang x-default tag -->
  {#if hreflangXDefault}
    <link rel="alternate" hreflang="x-default" href={ogUrl} />
  {/if}

  <!-- SEO Metadata Schema Script -->
  {#if metadataSeoSchemaScript}
    <!-- eslint-disable-next-line svelte/no-at-html-tags -->
    {@html metadataSeoSchemaScript}
  {/if}

  <!-- Twitter Card Metadata -->
  <meta name="twitter:card" content={twitterCard} />
  <meta name="twitter:site" content={twitterSite} />
  <meta name="twitter:creator" content={twitterCreator} />
  <meta name="twitter:domain" content={twitterDomain} />

  <!-- Verification Token Tags -->
  <meta name="p:domain_verify" content={pinterestVerificationToken} />
  <meta name="msvalidate.01" content={bingVerificationToken} />
  {#if googleSiteVerificationToken}
    <meta name="google-site-verification" content={googleSiteVerificationToken} />
  {/if}
  <meta name="sq:route" content={JSON.stringify(routeMetadata)} />

  <!-- OpenSearch XML -->
  <link
    type="application/opensearchdescription+xml"
    href={openSearchXmlUrl}
    rel="search"
    title="Search Square Support"
  />
</svelte:head>
